import Axios from '../axios'
import appConfig from '../../../app.config'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'

export interface CreateWithdrawalServiceParam {
	partyId: string | undefined
	firstName: string | undefined
	lastName: string | undefined
	nationalId: string | undefined
	accountAgreementId: string | undefined
	amount: number | undefined
	referenceAccountIban: string | undefined
	referenceAccountBic: string | undefined
	ocr: string | undefined
	nameOnReferenceAccount: string | undefined
	message: string | undefined
	closeAccount: boolean | undefined
}

export async function createWithdrawalService(
	body: CreateWithdrawalServiceParam,
) {
	return await Axios.post(
		`${appConfig.customerDataBaseUrl}/api/deposit/withdrawal/create`,
		body,
		await getHeadersWithJwtToken(),
	)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
